import React, { useState } from "react";
import { Menu } from "lucide-react";
import Sidebar from "../../component/Sidebar";

function EmployeeLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>

      <style>{`

        /* =================================
           EMPLOYEE MAIN LAYOUT
        ================================= */

        .employee-layout {

          display: flex;

          width: 100%;

          min-height: 100vh;

          background: #f8fafc;

          overflow-x: hidden;

        }


        /* =================================
           MOBILE TOP BAR (hamburger)
        ================================= */

        .employee-mobile-topbar {

          display: none;

        }


        /* =================================
           EMPLOYEE SIDEBAR
        ================================= */

        .employee-sidebar-wrapper {

          width: 250px;

          min-width: 250px;

          height: 100vh;

          position: fixed;

          top: 0;

          left: 0;

          z-index: 1000;

        }


        /* =================================
           MAIN CONTENT
        ================================= */

        .employee-content {

          width: calc(100% - 250px);

          min-height: 100vh;

          margin-left: 250px;

          padding: 25px;

          box-sizing: border-box;

          background: #f8fafc;

          overflow-x: hidden;

        }


        /* =================================
           CONTENT INNER
        ================================= */

        .employee-content-inner {

          width: 100%;

          max-width: 1600px;

          margin: 0 auto;

        }


        /* =================================
           TABLET
        ================================= */

        @media (max-width: 992px) {

          .employee-sidebar-wrapper {

            width: 220px;

            min-width: 220px;

          }


          .employee-content {

            width: calc(100% - 220px);

            margin-left: 220px;

            padding: 20px;

          }

        }


        /* =================================
           MOBILE
           Sidebar becomes a fixed slide-in
           drawer (handled inside Sidebar.jsx
           via the mobile-open class), so the
           wrapper and content column no longer
           need to reserve space for it.
        ================================= */

        @media (max-width: 768px) {

          .employee-layout {

            display: block;

          }


          .employee-mobile-topbar {

            display: flex;
            align-items: center;
            gap: 10px;

            padding: 12px 16px;

            background: #ffffff;
            border-bottom: 1px solid #e9e5ed;

            position: sticky;
            top: 0;
            z-index: 900;

          }

          .employee-mobile-topbar button {

            background: none;
            border: none;
            padding: 4px;
            color: #3E0F8D;
            cursor: pointer;
            display: flex;
            align-items: center;

          }

          .employee-mobile-topbar span {

            font-weight: 800;
            color: #3E0F8D;
            font-size: 15px;

          }


          .employee-sidebar-wrapper {

            width: 0;

            min-width: 0;

            height: 0;

            position: static;

          }


          .employee-content {

            width: 100%;

            margin-left: 0;

            padding: 15px;

          }

        }

      `}</style>


      <div className="employee-layout">


        {/* ===============================
            MOBILE TOP BAR
        =============================== */}

        <div className="employee-mobile-topbar">

          <button
            type="button"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>

          <span>CertED</span>

        </div>


        {/* ===============================
            EMPLOYEE SIDEBAR
        =============================== */}

        <div className="employee-sidebar-wrapper">

          <Sidebar
            isMobileOpen={mobileOpen}
            onClose={() => setMobileOpen(false)}
          />

        </div>


        {/* ===============================
            EMPLOYEE MAIN CONTENT
        =============================== */}

        <main className="employee-content">

          <div className="employee-content-inner">

            {children}

          </div>

        </main>


      </div>

    </>

  );

}

export default EmployeeLayout;